import { Tag } from '@components/core-ui/Tag';
import { Button } from '@components/core-ui/form-elements/buttons/Button';
import { Input } from '@components/core-ui/form-elements/Input';
import React, { useState } from 'react';

type TProps = {
  label: string;
  values: string[];
  onChange: (values: string[]) => void;
  validate: (value: string) => boolean;
  invalidMessage: string;
  placeholder?: string;
};

export const RouteListEditor = ({ label, values, onChange, validate, invalidMessage, placeholder }: TProps) => {
  const [draft, setDraft] = useState('');
  const [error, setError] = useState<string | null>(null);

  const addDraft = () => {
    const normalized = draft.trim().toLowerCase();
    if (!normalized) {
      return;
    }
    if (!validate(normalized)) {
      setError(invalidMessage);
      return;
    }
    if (values.includes(normalized)) {
      setError('Already added');
      return;
    }
    onChange([...values, normalized]);
    setDraft('');
    setError(null);
  };

  return (
    <div className="input-wrapper">
      <div className="label">{label}</div>
      <div className="flex items-start gap-2">
        <Input
          label={label}
          value={draft}
          placeholder={placeholder}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setDraft(e.target.value);
            setError(null);
          }}
          onKeyUp={(e: React.KeyboardEvent<HTMLInputElement>) => {
            if (e.key === 'Enter') {
              addDraft();
            }
          }}
        />
        <Button className="shrink-0" onClick={addDraft} disabled={!draft.trim()}>
          Add
        </Button>
      </div>
      {error ? (
        <div className="text-left text-xs text-[var(--color-danger)]" role="alert">
          {error}
        </div>
      ) : null}
      {values.length ? (
        <div className="flex flex-wrap gap-1.5 pb-2">
          {values.map((value) => (
            <Tag key={value} text={value} onDelete={() => onChange(values.filter((item) => item !== value))} />
          ))}
        </div>
      ) : null}
    </div>
  );
};
